// src/hooks/useNavigationActions.ts
import { useSearchParams } from "react-router-dom";
import { useUIStore } from "../store";

export const useNavigationActions = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const setSection = useUIStore((s) => s.setSection);

  const closeModal = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("product");
    params.delete("cartItem");

    setSearchParams(params);

    // 🔥 fuerza UI consistente
    setSection("home");
  };

  return { closeModal };
};